import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  DevicesApi,
  type PutDeviceRequestBody,
} from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  handleHTTPError,
  isHTTPError,
} from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

type Params = {
  deviceId: string
  body: PutDeviceRequestBody
}

/**
 * キオスク端末 (Device) の所属現場を更新する。
 * キオスク端末名・管理番号は Rump 管理のため更新できず、所属現場のみ更新する。
 */
export const useMutationUpdateDevice = () => {
  const queryClient = useQueryClient()
  const { showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: ({ deviceId, body }: Params) =>
      baseClient
        .getApi(DevicesApi)
        .updateDevice({ deviceId, putDeviceRequestBody: body })
        .catch(handleHTTPError),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.devicesAll })
    },
    onError: (error: unknown) => {
      if (isHTTPError(error)) {
        showErrorSnackbar(error.errors.join('\n'))
      } else {
        showErrorSnackbar('キオスク端末の更新に失敗しました')
      }
    },
  })
}
